export default function warn(s) {
  console.warn('[react-ga]', s);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ga/dist/esm/utils/console/warn.js
// module id = 230
// module chunks = 58